<template lang="pug">
  .component.component-backoffice-note(v-if="item")
    .card( v-if="$is('listing')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="3")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              InstructionButtons(:item="item")
          .field-value(slot="n1") IN{{item.id}}
          .field-value(slot="n2") {{item.title}}
          .field-value(slot="n2") {{item.subtitle}}
          .field-value(slot="n3") N° of steps
          .field-value(slot="n3") {{item.steps.length}}
          .field-url-detail(slot="actionPage")
            router-link(:to="{name:'instruction', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action
    .card( v-if="$is('entityList')")
      .inner-content
        cardN(:showBullets="true", :showAction="true", :columns="3")
          div(slot="actionBullets")
            dropdown(:icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
              InstructionButtons(:item="item", :vehicle="true")
          .field-value(slot="n1") IN{{item.id}}
          .field-value(slot="n2") {{item.instruction.title}}
          .field-value(slot="n2") {{item.instruction.subtitle}}
          .field-value(slot="n3") N° of steps
          .field-value(slot="n3") {{item.instruction.steps.length}}
          .field-url-detail(slot="actionPage")
            router-link(:to="{name:'instruction', params:{id:item.instruction.id}}")
              i.fa.fa-angle-right.fa-3x.action
</template>
<script type="text/babel">
  import CardN from 'components/structure/CardN'
  import Dropdown from '../structure/foundation/Dropdown'
  import InstructionButtons from "../structure/ui/actions/InstructionButtons";

  export default {
    name: "Instruction",
    components: {
      InstructionButtons,
      Dropdown,
      CardN,
    },
    data() {
      return {}
    },
    created() {

    },
    methods: {},
    computed: {},
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
</style>



// WEBPACK FOOTER //
// Instruction.vue?134ed5b2